<template>
    <div>
        <!--
        <vue-html2pdf
            ref="html2Pdf"
            filename="Valores PDR"
            pdf-format="a4"
            pdf-orientation="portrait"
            pdf-content-width="800px"
            :show-layout="false"
            :enable-download="false"
            :preview-modal="false"
            :pdf-magin="10"
            :manual-pagination="true"
            :paginate-elements-by-heigth="1100"
            @progress="onProgress($event)"
            @beforeDownload="openPdf">
            <section slot="pdf-content">
                <div v-for="item in pdrvaluesPdf" :key="item.index">
                    <section class="pdf-item" style="margin:2rem 2rem 0 2rem">
                        <div class="row col-12 bold font-xs">
                            Obra: {{item.obra}} &nbsp;&nbsp;|&nbsp;&nbsp;
                            ID Site: {{item.idSite}} &nbsp;&nbsp;|&nbsp;&nbsp;
                            Contrato: {{item.contrato}}
                        </div>
                        <div v-for="membro in item.membros" :key="membro.index" class="row col-12" style="font-size: x-small;">
                            <div class="col-6" >
                                {{membro.codigo}} - {{membro.nome}}
                            </div>
                            <div class="col-6">{{membro.funcao}}</div>
                            <div class="col-2" >Nota: {{membro.nota}}</div>
                            <div class="col-3" >Bruto: {{membro.bruto}}</div>
                            <div class="col-3" >Receb.: {{membro.recebido}}</div>
                            <div class="col-4" >Dt. receb.: {{membro.recebimento}}</div>
                            <div class="col-12">Obs.: {{membro.observacao}}</div>
                            <div class="col-12">&nbsp;</div>
                        </div>
                    </section>
                    <div v-if="item.index % 2 == 0 && item.membros.length > 1" class="html2pdf__page-break"></div>
                </div>
            </section>
        </vue-html2pdf>
    -->
        <b-container fluid style="height: calc(100vh - 181px);">
            <b-card id="card-principal" class="mb-0 pb-0">
                <template #header>
                    <div class="d-flex">
                        <div class="flex-grow-1">
                        <i class="fas fa-edit"></i>
                        <strong>{{$lang.PCI.PCIReports.PDRValues.Title}}</strong>
                        </div>
                    </div>
                    <div class="card-actions">
                        <!--
                        <b-link href="#" v-b-tooltip.hover :title="'Exportar PDF'" @click="generatePDF">
                            <i class="far fa-file-pdf" style="text-decoration: line-through"></i>
                        </b-link>
                        -->
                        <b-link href="#" v-b-tooltip.hover :title="'Filtrar'" @click="showModalFilter = true">
                            <i class="fas fa-search"></i>
                        </b-link>
                        <b-link href="#" v-b-tooltip.hover :title="'Visualizar e imprimir'" @click="printReport">
                            <i class="fas fa-print" style="text-decoration: line-through"></i>
                        </b-link>
                    </div>
                </template>
                <!--
                    <div style="display:inline;margin-bottom:.5em;font-weight:bold;cursor:pointer" @click="workTeamView()">
                        <i v-if="workTeamViewEnabled" class="fa fa-check-circle" style="font-size:15px;color:green"></i>
                        <i v-if="!workTeamViewEnabled" class="fa fa-circle" style="font-size:15px;color:lightgrey;"></i>
                        <span> {{$lang.PCI.PCIReports.PDRValues.ViewByWorkTeam}} :: </span>
                    </div>

                    <input style="width: 15rem;" type="text" :placeholder="filterPlaceholder" v-model="filterValue"/>
                -->

                <b-row class="min-vh-30" style="height: calc(100vh - 270px);">
                    <b-col cols="12" class="py-3">
                        <ag-grid-vue
                            class="ag-theme-alpine"
                            :getLocaleText="localeTextFunc"
                            :defaultColDef="defaultColumnDef"
                            :gridOptions="gridOptions2"
                            :columnTypes="columnTypes"
                            :columnDefs="columnDefs"
                            :rowData="pdrvalues"
                            :excelStyles="excelStyles"
                            rowSelection="multiple"
                            @gridReady="onGridReady"
                            @filterChanged="onFilterChanged"
                            :getContextMenuItems="getContextMenuItems"
                            :rowHeight="25"
                            style="width: 100%; height: 100%; border-radius: 6px;"
                        >
                        </ag-grid-vue>
                    </b-col>
                </b-row>
                <b-row style="display: flow-root;margin-top: -1em;">
                    <b-col cols="12">
                        <span style="font-size: small;font-weight: bold;">Total: </span>
                        {{ totalRows }}
                        &nbsp; &nbsp; | &nbsp; &nbsp;
                        <span style="font-size: small;font-weight: bold;">Valor Bruto: </span>
                        {{ totalValueRows }}
                        &nbsp; &nbsp; | &nbsp; &nbsp;
                        <span style="font-size: small;font-weight: bold;">Valor Recebido: </span>
                        {{ totalValuePaidRows }}
                    </b-col>
                </b-row>
            </b-card>
        </b-container>

        <!-- Modal Filtro -->
        <b-modal
            v-model="showModalFilter"
            title="Filtrar"
            size="md"
            :hide-footer="true"
            :no-close-on-backdrop="true"
            :no-close-on-esc="true"
            centered
        >
            <div class="form-group">
                <b-row>
                    <!-- data inicio -->
                    <b-col cols="6">
                        <label for="startDate">Data Inicial:</label>
                        <b-form-input type="date" class="form-control" id="startDate" v-model="modalFilterData.startDate"/>
                    </b-col>
                    <!-- data fim -->
                    <b-col cols="6">
                        <label for="endDate">Data Final:</label>
                        <b-form-input type="date" class="form-control" id="endDate" v-model="modalFilterData.endDate"/>
                    </b-col>
                </b-row>
                <b-row>
                    <!-- funcionario -->
                    <b-col cols="6">
                        <label for="employee">Funcionário:</label>
                        <b-form-input type="text" class="form-control" id="employee" v-model="modalFilterData.employee"/>
                    </b-col>
                    <!-- opção []funcionario []cordenador -->
                    <b-col cols="6">
                        <label for="filterOption">Opção:</label>
                        <select class="form-control" id="filterOption" v-model="modalFilterData.option">
                            <option value="1">Funcionário</option>
                            <option value="2">Coordenador</option>
                        </select>
                    </b-col>
                </b-row>
                <hr/>
                <div class="mt-4" style="display: flex;flex-direction: row-reverse;">
                    <button type="button" class="btn btn-third btn-sm" v-on:click="filter" v-b-tooltip.hover>
                        <i class="fa fa-check"></i>&nbsp;&nbsp;Filtrar
                    </button>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
import Spreadsheet from './PDRValuesReport'
export default Spreadsheet
</script>



// WEBPACK FOOTER //
// src/views/private/operational/pci/reports/PDRValuesReport.vue